import type { KanbanComment } from '@entities/kanban-comment'

import { useKanbanCommentsStore } from '@entities/kanban-comment'
import { useCommonStore } from '@shared/model'
import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface UpdateCustomerTaskCommentApiOptions {
  taskId: string | number
  commentId: string | number
  comment: string
  onStart?: () => void
  onSuccess?: (data: KanbanComment) => void
  onError?: (err: unknown) => void
  onFinish?: () => void
}

export const useUpdateCustomerTaskCommentApi = async (options: UpdateCustomerTaskCommentApiOptions): Promise<KanbanComment | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.kanban-tasks.comments.update', {
    task_id: options.taskId,
    comment_id: options.commentId,
  })

  const kanbanCommentsStore = useKanbanCommentsStore()
  const commonStore = useCommonStore()

  options.onStart?.()
  commonStore.setLoading(true)

  try {
    const { data } = await $axios.patch(url!, { comment: options.comment })
    const comment: KanbanComment = data.data

    kanbanCommentsStore.updateComment(comment)
    commonStore.setLoading(false)

    options.onSuccess?.(comment)

    return comment
  } catch (err: unknown) {
    console.error(err)
    toast.error(getAxiosErrorMessage(err))
    commonStore.setLoading(false)
    options.onError?.(err)

    return null
  } finally {
    options.onFinish?.()
  }
}